import i18n from '@/i18n';
import fetchData from '@/api/fetch';
import { sessionOrLocal, getQueryString, clearCookies, parseToken } from '@/tools/utils.js';
import { message as $vhMessage } from '@/tools/reset-message.js';
import Cookies from 'js-cookie';
import tojs from 'await-to-js';
import $store from '@/store';
import { initRecordInfo } from './record.js';
import { emitter, EMIT_DEFINE } from '@/tools/emitter.js';
import log from 'loglevel';
let $MsgChat;

/**
 * 路由权限检测(标品)
 * @param {*} to
 * @param {*} from
 * @param {*} next
 * @returns
 */
export async function checkAuth(to, from, next) {
  // 第一步，判断是否控制台 或者 地址栏token携带进入
  let token = sessionOrLocal.get('token', 'localStorage') || '';
  if (!token) {
    $vhMessage.error(`${i18n.t('ai.k_002001')}`);
    return;
  }

  // 第二步，初始化回放信息，拿到活动id和其它信息
  if (!$store.state.video.recordInfo || $store.state.video.recordInfo.id != to.params.id) {
    await initRecordInfo(to.params.id);
  }
  if (!$store.state.video.recordInfo) {
    return;
  }

  // 第三步，获取 权限配置信息、用户信息、活动信息
  if (!$store.state.userInfo || !$store.state.permissions || !$store.state.webinarInfo) {
    const { user_id, webinar_id } = $store.state.video.recordInfo;
    // 获取权限信息
    const funGetConfigs = fetchData('planFunctionGet', {
      webinar_id: webinar_id,
      webinar_user_id: user_id,
      scene_id: 1
    });
    // 获取用户信息
    const funGetInfo = fetchData('getInfo', {
      scene_id: 2
    });
    // 获取活动信息
    const funGetWebinarInfo = fetchData('getWebinarInfo', {
      webinar_id
    });

    // 并发执行
    const [err, result] = await tojs(Promise.all([funGetConfigs, funGetInfo, funGetWebinarInfo]));
    log.info('checkAuth:', result);

    /* prettier-ignore */
    if (err || !result || result[0].code !== 200 || result[1].code !== 200 || result[2].code !== 200) {
      log.error('err:', err);
      $vhMessage.error(`${i18n.t("ai.k_002002")}`);
      let out_url = sessionOrLocal.get('SAAS_V3_CTRL_OUT', 'localStorage');
      // sessionStorage.clear();
      // localStorage.clear();
      if (result && result[0]?.code == 511006) {
        if (out_url) {
          // 清除cookies
          Cookies.remove('gray-id');
          window.location.href = out_url;
        } else {
          // next({ path: '/login', query: { form: isOld == 1 ? 1 : 0 } });
        }
      }
      // sessionOrLocal.removeItem('SAAS_VS_PES');
      return;
    }
    // 缓存权限
    let permissions_str = result[0].data.permissions;
    const permissions = JSON.parse(permissions_str);
    $store.commit('setPermissions', permissions);

    // 缓存用户信息
    $store.commit('setUserInfo', result[1].data);

    //缓存活动信息
    $store.commit('setWebinarInfo', result[2].data);
  }

  // 权限及账号超期校验
  if (!checkPermissions(next, `/noauth/${to.params.id}`)) {
    return;
  }
  next();
}

/**
 * 路由权限检测(嵌入)
 * @param {*} to
 * @param {*} from
 * @param {*} next
 * @returns
 */
export async function checkAuthForEmbed(to, from, next) {
  let userId; // 用户id
  const isWxworkRouter = to.path.indexOf('/wxwork/') > -1;
  // 第一步，判断是否控制台 或者 地址栏token携带进入
  let token = sessionOrLocal.get('token', 'localStorage') || '';
  if (!token) {
    if (!isWxworkRouter) {
      $vhMessage.error(`${i18n.t('ai.k_002001')}`);
      return;
    }
    // 企微授权后返回的authKey
    const auth_key = getQueryString('authKey');
    log.info('auth_key:', auth_key);
    if (to.path.indexOf('/embed/wxwork/material') > -1 && auth_key) {
      // 检测企微授权是否绑定
      const [checkErr, checkResult] = await tojs(
        fetchData('checkBindBusiness', {
          auth_key
        })
      );
      log.info('checkErr:', checkErr);
      log.info('checkResult:', checkResult);
      if (checkErr || !checkResult || checkResult.code != 200 || !checkResult.data) {
        $vhMessage.error(checkErr?.msg || checkResult?.msg || `${i18n.t('ai.k_002003')}`);
        next('/embed/wxwork/login');
        return;
      }
      // already_bind 是否绑定过B端用户，0未绑定 1已绑定过
      // business_uid 绑定B端用户的uid
      // token B端用户token（已绑定过，返回的是绑定用户的token；未绑定时，值是空的）
      if (checkResult.data.already_bind == 1 && checkResult.data.token) {
        sessionOrLocal.set('token', checkResult.data.token || '', 'localStorage');
        sessionOrLocal.set('tokenRefresh', new Date().getTime(), 'localStorage');
        // 用户登录完成后，用户ID写入Cookie
        Cookies.set('gray-id', checkResult.data.business_uid, {
          expires: 30
        });
        token = checkResult.data.token;
        userId = checkResult.data.business_uid;
      } else {
        // 去绑定
        sessionOrLocal.set('wxwork_auth_key', auth_key);
        next('/embed/wxwork/login');
        return;
      }
    } else {
      // 跳转到登录页面
      next('/embed/wxwork/login');
      return;
    }
  }

  // userId不存在，则从token中解出 userId
  try {
    if (!userId) {
      const tokenJson = parseToken(token);
      userId = tokenJson?.user_id;
      if (!userId) {
        throw new Error(`${i18n.t('ai.k_002004')}`);
      }
      if (tokenJson.exp && !sessionOrLocal.get('tokenExpiredTime', 'localStorage')) {
        sessionOrLocal.set('tokenExpiredTime', tokenJson.exp, 'localStorage');
      }
    }
  } catch (ex) {
    log.error('解析用户信息失败:', ex);
    sessionOrLocal.clear();
    sessionOrLocal.clear('localStorage');
    clearCookies(); // 清空缓存 - cookies缓存
    // 跳转到登录页面
    next('/embed/wxwork/login');
    return;
  }

  // 获取权限信息 和 用户信息
  if (!$store.state.userInfo || !$store.state.permissions) {
    // 获取用户信息
    const funGetInfo = fetchData('getInfo', {
      scene_id: 2
    });

    // 获取权限信息
    const funGetConfigs = fetchData('planFunctionGet', {
      webinar_user_id: userId,
      scene_id: 1
    });

    // 并发执行
    const [err, result] = await tojs(Promise.all([funGetConfigs, funGetInfo]));
    log.info('获取权限信息 和 用户信息 result:', result);
    if (err || !result || result[0].code !== 200 || result[1].code !== 200) {
      log.info('获取权限信息 和 用户信息 err:', err);
      $vhMessage.error(`${i18n.t('ai.k_002002')}`);
      let out_url = sessionOrLocal.get('SAAS_V3_CTRL_OUT', 'localStorage');
      // sessionStorage.clear();
      // localStorage.clear();
      if (result && result[0]?.code == 511006) {
        if (out_url) {
          // 清除cookies
          Cookies.remove('gray-id');
          window.location.href = out_url;
        } else {
          // next({ path: '/login', query: { form: isOld == 1 ? 1 : 0 } });
        }
      }
      // sessionOrLocal.removeItem('SAAS_VS_PES');
      return;
    }
    // 缓存权限
    let permissions_str = result[0].data.permissions;
    const permissions = JSON.parse(permissions_str);
    $store.commit('setPermissions', permissions);

    // 缓存用户信息
    $store.commit('setUserInfo', result[1].data);
  }
  if (to.path.indexOf('/embed/wxwork/noauth') > -1) {
    next();
    return;
  }

  // 权限及账号超期校验
  if (!checkPermissions(next, isWxworkRouter ? '/embed/wxwork/noauth' : '/noauth')) {
    return;
  }
  if (to.params.id) {
    if ($store.state.video.recordInfo && to.params.id != $store.state.video.recordInfo.vod_id) {
      $store.commit('video/setRecordInfo', null);
      $store.commit('video/setPlayBackInfo', null);
    }
    if (!$store.state.embedCfg.feature || !$store.state.video.recordInfo) {
      // 获取嵌入页配置
      const funEmbedConfig = fetchData('getConfigInfo', {
        keys: 'ui_theme,feature'
      });

      // 初始化回放信息
      const funInitRecordInfo = initRecordInfo(to.params.id);

      // 并发执行
      const [err, result] = await tojs(Promise.all([funEmbedConfig, funInitRecordInfo]));
      log.info('嵌入页 并发执行 result:', result);
      if (err || !result || result[0].code !== 200) {
        log.error('嵌入页 并发执行 err:', err);
        $vhMessage.error(`${i18n.t('ai.k_002002')}`);
      }
      const embedConfig = result[0].data.config;
      // 主题色配置
      if (embedConfig?.ui_theme) {
        try {
          const uiThemeObj = JSON.parse(embedConfig.ui_theme);
          if (uiThemeObj) {
            $store.commit('embedCfg/setUiTheme', uiThemeObj);
          }
        } catch (ex) {
          console.error('embedConfig.ui_theme parse error:', ex);
        }
      }
      // 功能配置
      if (embedConfig?.feature) {
        try {
          const featureObj = JSON.parse(embedConfig.feature);
          if (featureObj) {
            $store.commit('embedCfg/setFeature', featureObj);
          }
        } catch (ex) {
          console.error('embedConfig.feature parse error:', ex);
        }
      }
    }
    // 如果没有配置跳转404
    if (to.meta.feature && !$store.state.embedCfg?.feature[to.meta.feature]) {
      return next('/404');
    }
    if (!$store.state.video.recordInfo) {
      return;
    }
  }
  next();
}

// 统一权限校验及账号超期校验
async function checkPermissions(next, redirctUri) {
  if ($store.state.permissions['ai_creation'] !== 1) {
    // 没有权限
    if (next && redirctUri) {
      next(redirctUri);
    }
    return false;
  }
  if (typeof $store.state.versionExpired !== 'boolean') {
    // 如果有权限，判断账号是否到期
    const [error, versionInfo] = await tojs(
      fetchData('getVersionInfo', {
        user_id: $store.state.userInfo.user_id
      })
    );
    if (error || !versionInfo || versionInfo.code != 200) {
      $vhMessage.error(versionInfo?.msg || versionInfo?.msg || `${i18n.t('ai.k_002005')}`);
      return false;
    }
    $store.commit('setVersionExpired', versionInfo.data.expired == 1);
  }
  if ($store.state.versionExpired) {
    // 账号到期
    if (next && redirctUri) {
      next(`${redirctUri}?expired=1`);
    }
    return false;
  }
  return true;
}

// 初始化消息
export async function initMsgChat() {
  let result = await fetchData('msgInitConsole');
  log.info('msgInitConsole result:', result);
  if (result && result.code == 200) {
    let option = {
      appId: result.data.paasAppId || '',
      // appId 必须
      accountId: result.data.accountId || '',
      // 第三方用户ID
      channelId: result.data.channelId || '',
      // 频道id 必须
      token: result.data.paasAccessToken || '',
      // 必须， token，初始化接口获取
      hide: true
    };
    window.VhallChat.createInstance(
      option,
      event => {
        $MsgChat = event.message; // 聊天实例句柄
        msgMonitor();
      },
      err => {
        // alert('初始化错误')
        console.error(err);
      }
    );
  }
}

/**
 * 消息监听
 * @returns
 */
function msgMonitor() {
  if (!$MsgChat) return;
  log.info('--- msgMonitor  start');
  $MsgChat.onCustomMsg(async msg => {
    try {
      if (typeof msg !== 'object') {
        msg = JSON.parse(msg);
      }
      if (typeof msg.context !== 'object') {
        msg.context = JSON.parse(msg.context);
      }
      if (typeof msg.data !== 'object') {
        msg.data = JSON.parse(msg.data);
      }
    } catch (e) {
      log.error('onCustomMsg error:', e);
    }
    log.info('onCustomMsg 收到消息: ' + JSON.stringify(msg.data));
    if (msg.data.type === 'vod_ai_parsing_complete') {
      // 智能解析完成
      emitter.emit(EMIT_DEFINE.msgVodAiParsingAsrComplete, msg.data);
      //   {
      //     "record_id": 794503,
      //     "file_url": "https://t-tehlsvodhls02.vhallyun.com/vhallyun/vhallcoop/ca13f64453652b3ec0c86f4731804955/44ec50bb/44ec50bb_20240314150227_asr.json",
      //     "user_id": 101643,
      //     "vod_id": "44ec50bb",
      //     "type": "vod_ai_parsing_complete",
      //     "lang": "en",
      //     "status": 1
      //   }
    } else if (msg.data.type === 'vod_ai_moments_complete') {
      // {
      //   file_url: 'http://t-tehlsvodhls02.vhallyun.com/vhallyun/vhallrecord/lss_0bc1da00/20240105180022_16322d00/16322d00_36_ai_highlight.json';
      //   record_id: 793506;
      //   status: 1;
      //   type: 'vod_ai_moments_complete';
      //   user_id: 127233;
      //   vod_id: '16322d00';
      // }
      emitter.emit(EMIT_DEFINE.VodAIHighlightComplete, msg.data);
    } else if (msg.data.type === 'vod_ai_summary_complete') {
      emitter.emit(EMIT_DEFINE.VodAISummaryComplete, msg.data);
    } else if (msg.data.type === 'vod_ai_clip_complete') {
      // 精彩剪辑创建完成消息
      emitter.emit(EMIT_DEFINE.msgVodAiClipComplete, msg.data);
      //
    } else if (msg.data.type === 'vod_ai_clip_custom_add_complete') {
      // 精彩剪辑新增完成消息
      emitter.emit(EMIT_DEFINE.msgVodAiClipCustomAddComplete, msg.data);
      //
    } else if (msg.data.type === 'vod_download_progress') {
      // 精彩剪辑打包进度
      emitter.emit(EMIT_DEFINE.msgVodAiClipDownloadProgress, msg.data);
    } else if (msg.data.type === 'record_download') {
      // 精彩剪辑打包完成
      emitter.emit(EMIT_DEFINE.msgVodAiClipDownloadComplete, msg.data);
    } else if (msg.data.type === 'sign_trans_code') {
      // 音视频上传转码进度
      emitter.emit(EMIT_DEFINE.msgVidoeTransStatus, msg.data);
    }
  });
}

/**
 * vuex存储重置为初始状态
 */
export const clearVuexStore = () => {
  $store.replaceState({
    // 用户信息
    userInfo: null,
    // 权限信息
    permissions: null,
    // 活动信息
    webinarInfo: null,
    // 账号是否到期, 到期：true, 未到期：false
    versionExpired: null,
    // embedCfg模块的初始状态
    embedCfg: {
      // UI主题配置
      uiTheme: null,
      // 功能模块配置
      feature: null
    },
    // video模块的初始状态
    video: {
      recordInfo: null,
      //回放信息(SaaS和PaaS共用)
      playBackInfo: null,
      asrStatus: -1,
      // 语音识别结果查询状态, -1 未知，0:不存在，1:成功，2:失败，3:进行中 4: 重新（继续）校正 10: 校正完成
      asrLang: 'zh',
      // 语音识别结果语言： zh：中文， en：英文
      asrData: null,
      // 语音识别结果数据
      isPlaying: false,
      // 视频是否在播放中
      totalTime: null,
      //视频总时长
      markpoints: [],
      //视频打点
      hasVodDoc: false,
      // 是否有回放文档
      clipStatus: -1 // 精彩剪辑查
    },
    sidebar: {
      isCollapse: false
    }
  });
};
